import styled from 'styled-components';

export const StyledList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
  align-items: center;
  max-width: 888px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 50px;
`;
